import { Outlet } from "react-router-dom";
import Header from "../Commons/Header/Header";
import Sidebar from '../Commons/Sidebar/Sidebar'

const MainLayout = () => {
  return (
    <>
      <Header />
      <div className="docs-wrapper">
        <Sidebar />
      </div>
      <Outlet />
    </>
  );
};

export default MainLayout;